import { render, staticRenderFns } from "./data50.vue?vue&type=template&id=07a4cebc&scoped=true"
import script from "./data50.vue?vue&type=script&lang=js"
export * from "./data50.vue?vue&type=script&lang=js"
import style1 from "./data50.vue?vue&type=style&index=1&id=07a4cebc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a4cebc",
  null
  
)

export default component.exports